import { useLingui } from "@lingui/react";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";

export function AdminSystemOverviewCard() {
  const { i18n } = useLingui();

  return (
    <Card>
      <CardHeader>
        <CardTitle>{i18n._("System Overview")}</CardTitle>
        <CardDescription>{i18n._("Current system status")}</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-3">
          <div className="flex justify-between items-center">
            <span className="text-sm text-(--color-text-secondary)">
              {i18n._("Database Status")}
            </span>
            <span className="text-sm font-medium text-(--color-success-text)">
              ● {i18n._("Connected")}
            </span>
          </div>
          <div className="flex justify-between items-center">
            <span className="text-sm text-(--color-text-secondary)">
              {i18n._("API Status")}
            </span>
            <span className="text-sm font-medium text-(--color-success-text)">
              ● {i18n._("Healthy")}
            </span>
          </div>
          <div className="flex justify-between items-center">
            <span className="text-sm text-(--color-text-secondary)">
              {i18n._("Environment")}
            </span>
            <span className="text-sm font-medium">{import.meta.env.MODE}</span>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
